// extracted by mini-css-extract-plugin
module.exports = {"eventsOrderBySelect":"eventsOrderBySelect_eventsOrderBySelect__oTlgL"};